const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_EMAIL(state, email) {
    state.email = email
  },
  UPDATE_FIX_PHONE_NO(state, fixPhoneNo) {
    state.fixPhoneNo = fixPhoneNo
  },
  UPDATE_MOBILE_PHONE_NO(state, mobilePhoneNo) {
    state.mobilePhoneNo = mobilePhoneNo
  },
  UPDATE_FAX_NO(state, faxNo) {
    state.faxNo = faxNo
  },

}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateEmail({
    commit
  }, email) {
    commit('UPDATE_EMAIL', email);
  },
  updateFixPhoneNo({
    commit
  }, fixPhoneNo) {
    commit('UPDATE_FIX_PHONE_NO', fixPhoneNo);
  },
  updateMobilePhoneNo({
    commit
  }, mobilePhoneNo) {
    commit('UPDATE_MOBILE_PHONE_NO', mobilePhoneNo);
  },
  updateFaxNo({
    commit
  }, faxNo) {
    commit('UPDATE_FAX_NO', faxNo);
  }
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  Email: state => {
    return state.email
  },
  FixPhoneNo: state => {
    return state.fixPhoneNo
  },
  MobilePhoneNo: state => {
    return state.mobilePhoneNo
  },
  FaxNo: state => {
    return state.faxNo
  },
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      id: 0,
      email: "",
      fixPhoneNo: "",
      mobilePhoneNo: "",
      faxNo: ""
    }
  },
  getters,
  actions,
  mutations
}
